package fr.frux.core.designsystem.system

import androidx.compose.runtime.Composable

/** Pas de barre d'état dans un navigateur. */
@Composable
actual fun StatusBarIconsEffect(lightIcons: Boolean) = Unit
